import { render, staticRenderFns } from "./MainSettings.vue?vue&type=template&id=13c461fc&scoped=true"
import script from "./MainSettings.vue?vue&type=script&lang=js"
export * from "./MainSettings.vue?vue&type=script&lang=js"
import style0 from "./MainSettings.vue?vue&type=style&index=0&id=13c461fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c461fc",
  null
  
)

export default component.exports